
export default class Config {
    static base_url: string = "https://9257lkuvmh.execute-api.us-east-1.amazonaws.com/dev";
}